export default function (performances) {
  const now = new Date().getTime();

  return performances.filter(function (performance) {
    let date = null;

    if ('perf_date' in performance) {
      date = performance.perf_date;
    } else if ('perf_dt' in performance) {
      date = performance.perf_dt;
    }

    if (!date) {
      return false;
    }

    return new Date(date).getTime() >= now;
  });
}



// WEBPACK FOOTER //
// ./src/javascripts/lib/common/filterPastPerformances.js